import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import type { ImportModel, ImportType } from "../../domain/models/Import";
import { importMutationService } from "../../services/payments/ImportMutationService";
type UploadImportInput = {
  file: File;
  type: ImportType;
};
export function useUploadImport() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
function _temp(t0) {
  const {
    file,
    type
  } = t0;
  return importMutationService.uploadPaymentFile(file, type);
}